import React from "react";
import { useOverrides } from "@quarkly/components";
import { Link } from "@quarkly/widgets";
import { globalHistory } from "@reach/router";

const addUtmParams = (url, utmParams, paramToKeep) => {
	const searchParams = new URLSearchParams(url.search); // if (paramToKeep) {
	//   searchParams.set(paramToKeep, utmSourceVal);
	// } else {
	//   for (const [key, value] of utmParams.entries()) {
	//     if (!searchParams.has(key)) {
	//       searchParams.append(key, value);
	//     }
	//   }
	// }

	const oldVal = searchParams.get('start');
	const utmSourceVal = utmParams.get(paramToKeep);

	if (oldVal && utmSourceVal) {
		searchParams.set('start', `${oldVal}_${utmSourceVal}`);
	}

	const fullURL = new URL(url.origin + url.pathname);
	fullURL.search = searchParams.toString();
	fullURL.hash = url.hash;
	return fullURL.toString();
};

const defaultProps = {
	"href": "https://t.me/uShopWebBot?start=web",
	"color": "--white",
	"font": "--button",
	"text-decoration-line": "initial",
	"padding": "12px 24px 12px 24px",
	"background": "--dark",
	"border-radius": "50px",
	"transition": "--opacityOut",
	"hover-opacity": ".8",
	"target": "_blank",
	"md-padding": "12px 20px 12px 20px",
	"text-align": "center",
	"className": "linkBot",
	"children": "Создать веб-бота"
};
const overrides = {};

const ButtonBot = props => {
	const {
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	const {
		href,
		...rest2
	} = rest;
	const pageSearchParam = new URLSearchParams(globalHistory.location.search);
	const updatedHref = addUtmParams(new URL(href), pageSearchParam, 'utm_source');
	return <Link href={updatedHref} {...rest2}>
		    
		{children}
		  
	</Link>;
};

Object.assign(ButtonBot, { ...Link,
	defaultProps,
	overrides
});
export default ButtonBot;